const APIExamplesContent = {
  /* ==========================================================================
   * Blacklists
   * ==========================================================================
   */
  // Hostnames
  "Hostnames": {
    "Description": "Hostnames Blacklisted by HoneyShare",
    "Examples": {
      "python": `from honeyshare import HoneyShare

hs = HoneyShare(key="Your HoneyShare Key")
hs.Blacklist.hostnames()`,
      "url": "https://honeyshare.live/honey/blacklist/hostnames",
    },
    "Output": `[
    "mal-xious.org.",
    "blark-visted.tv.io.",
    "honey.trapped.xxx.",
    ...
]`
  },

  // IPs
  "IPs": {
    "Description": "IPs Blacklisted by HoneyShare",
    "Examples": {
      "python": `from honeyshare import HoneyShare

hs = HoneyShare(key="Your HoneyShare Key")
hs.Blacklist.ipv4s()`,
      "url": "https://honeyshare.live/honey/blacklist/ipv4s",
    },
    "Output": `[
    "196.xxx.xxx.83",
    "152.xxx.xxx.166",
    "87.xxx.xxx.173",
    ...
]`
  },

  /* ==========================================================================
   * Analysis
   * ==========================================================================
   */
  // Hostname Search
  "Hostname Search": {
    "Description": "Search for Hostnames",
    "Examples": {
      "python": `from honeyshare import HoneyShare

hs = HoneyShare(key="Your HoneyShare Key")
hs.Hostname.list(search="mal-xious")
hs.Hostname.list(glob="*.mal-xious.tv")`,
      "url": "https://honeyshare.live/honey/hostname?search=mal-xious",
    },
    "Output": `// Search
[{"Hostname":  "foo.mal-xious.org",
  "IPv4":      "185.247.xxx.xxx",
  "Timestamp": "2025-09-17T07:14:41Z"},
 {"Hostname":  "bar.mal-xious.org",
  "IPv4":      "185.247.xxx.xxx",
  "Timestamp": "2025-06-02T14:34:08Z"},
 {"Hostname":  "baz.mal-xious.tv",
  "IPv4":      "185.248.xxx.xxx",
  "Timestamp": "2025-03-26T22:52:52Z"}
]

// Glob
[{"Hostname":  "baz.mal-xious.tv",
  "IPv4":      "185.248.xxx.xxx",
  "Timestamp": "2025-03-26T22:52:52Z"}
]
`
  },

  // IP Range Search
  "IP Range Search": {
    "Description": "IP Range Search",
    "Examples": {
      "python": `from honeyshare import HoneyShare

hs.IPv4.list(range="185.247.0.0/16")`,
      "url": "https://honeyshare.live/honey/ipv4?range=185.247.0.0/16",
    },
    "Output": `[{"IPv4":        "185.247.xx2.12",
  "CountryCode": "DE",
  "Hostname":    "foo.mal-xious.org",
  "LastSeen":    "2025-09-17T07:14:41Z"},
 {"IPv4":        "185.247.xx3.84",
  "CountryCode": "DE",
  "Hostname":    "bar.mal-xious.org",
  "LastSeen":    "2025-06-02T14:34:08Z"}
]`
  },

  // Volumes and PCAPs
  "Volumes and PCAPs": {
    "Description": "Download Volumes and PCAPs",
    "Examples": {
      "python": `from honeyshare import HoneyShare

# Search for connections with Volumes and PCAPs
hs.Timeseries().list(has_volume=True, has_pcap=True)
hs.IPv4("185.247.xxx.xxx") \\
  .timeseries(port=22, has_volume=True, has_pcap=True)

# Download Honeypot's Volume
hs.Timeseries(123).volume("volume.tar")

# Download attacks PCAP
hs.Timeseries(123).pcap("capture.pcap")`,
      "url": "https://honeyshare.live/honey/ipv4/185.247.xxx.xxx/timeseries?has_volue=true&has_pcap=true",
    },
    "Output": `[{"Timestamp": "2025-09-17T07:14:41Z"
  "ID":        123,
  "IPv4":      "185.247.xxx.xxx",
  "Port":      "22",
  "HasVolume": true,
  "HasPCAP":   true}]`
  },

  // Payload Analysis
  "Payload Analysis": {
    "Description": "The payload sent by an attacker or scanner is kept",
    "Examples": {
      "python": `from honeyshare import HoneyShare

hs.IPv4("185.247.xxx.xxx").payload(80, base64_decode=True)`,
      "url": "https://honeyshare.live/honey/ipv4/185.247.xxx.xxx/ports/80/payload",
    },
    "Output": `{"IPv4": "185.247.xxx.xxx",
 "Port": "80",
 "Connections": [{
   "Timestamp": "2025-09-17T07:14:41Z",
   "Payload":   "CONNECT httpbin.org:443 HTTP/1.1\\r\\n"
                "Host: httpbin.org:443\\r\\n"
                "User-Agent: Go-http-client/1.1\\r\\n"
   }, {
   "Timestamp": "2025-09-16T22:01:33Z",
   "Payload":   "GET / HTTP/1.1\\r\\n"
                "Host: 104.248.23.114:80\\r\\n"
}]}`
  },

  // Connections On Port
  "Connections On Port": {
    "Description": "Connections On Port Over Time",
    "Examples": {
      "python": `from honeyshare import HoneyShare

hs = HoneyShare(key="Your HoneyShare Key")
hs.IPv4("196.xxx.xxx.83").timeseries(port="27017")`,
      "url": "https://honeyshare.live/honey/ipv4/196.xxx.xxx.83/ports/27017/timeseries",
    },
    "Output": `{
    "IPv4": "196.xxx.xxx.83",
    "Port": "27017",
    "Connections": [
        "2025-05-29T03:46:25.470825Z",
        "2025-05-29T03:46:24.926468Z",
        "2025-05-29T03:46:24.41066Z",
        ...
    ]
}`
  },

  // IPs for Hostname
  "IPs for Hostname": {
    "Description": "IPs for Hostname Over Time",
    "Examples": {
      "python": `from honeyshare import HoneyShare

hs = HoneyShare(key="Your HoneyShare Key")
hs.Hostname("mal-xious.org.").ipv4()`,
      "url": "/hostnames/mal-xious.org./ipv4",
    },
    "Output": `{
    "Hostname": "mal-xious.org.",
    "IPv4": [{
        "Timestamp": "2025-05-29T03:46:25.470825Z",
        "IPv4": "196.xxx.xxx.83"
    }, {
        "Timestamp": "2025-05-29T03:46:24.926468Z",
        "IPv4": "196.xxx.xxx.83"
    }, {
        "Timestamp": "2025-05-29T03:46:24.41066Z",
        "IPv4": "196.xxx.xxx.83"
    }, ... ]
}`
  },

  // Hostnames for IPs
  "Hostnames for IPs": {
    "Description": "Hostnames for IPs Over Time",
    "Examples": {
      "python": `from honeyshare import HoneyShare

hs = HoneyShare(key="Your HoneyShare Key")
hostnames = hs.IPv4("196.xxx.xxx.83").hostnames()`,
      "url": "/ipv4/196.xxx.xxx.83/hostnames",
    },
    "Output": `{
    "IPv4": "196.xxx.xxx.83",
    "Hostnames": [{
        "Timestamp": "2025-05-29T03:46:25.470825Z",
        "Hostname": "mal-xious.org."
    }, {
        "Timestamp": "2025-03-26T09:13:24.9168Z",
        "Hostname": "blark-visted.tv.io."
    }, {
        "Timestamp": "2025-01-08T09:33:22.48906Z",
        "Hostname": "honey.trapped.xxx."
    }, ... ]
}`
  },
};

export default APIExamplesContent;
